// Material Dashboard 2 PRO React TS Base Styles
import borders from "app/assets/theme/base/borders";
import colors from "app/assets/theme/base/colors";

// Material Dashboard 2 PRO React Helper Function
import rgba from "app/assets/theme/functions/rgba";

const { black, white } = colors;
const { borderWidth, borderRadius } = borders;

// types
// types
type Types = any;

const card: Types = {
  styleOverrides: {
    root: {
      display: "flex",
      flexDirection: "column",
      position: "relative",
      minWidth: 0,
      wordWrap: "break-word",
      backgroundColor: white.main,
      backgroundClip: "border-box",
      border: `${borderWidth[0]} solid ${rgba(black.main, 0.125)}`,
      borderRadius: borderRadius.xl,
      overflow: "visible",
    },
  },
};

export default card;
